import { PasswordInput } from "@/components/PasswordInput";
import { FormField } from "@/components/forms/FormField";
import { passwordScore } from "@/lib/validators";

const LEVELS = [
  ["Molto debole", "#DC2626"], ["Molto debole", "#DC2626"], ["Debole", "#EA580C"],
  ["Media", "#E0A800"], ["Buona", "#0D9488"], ["Forte", "#15803D"],
];

export const StrengthMeter = ({ value, testId }) => {
  const s = passwordScore(value);
  const [label, color] = LEVELS[s];
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div className="flex flex-1 gap-1.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <span key={i} className="h-1.5 flex-1 rounded-full transition-colors duration-300" style={{ background: i <= s ? color : "#E2E5DC" }} />
        ))}
      </div>
      {value && <span className="w-24 text-right text-xs font-semibold" style={{ color }} data-testid={`${testId}-label`}>{label}</span>}
    </div>
  );
};

export const PasswordFields = ({ value, confirm, onChange, onConfirm, errors = {}, prefix }) => (
  <div className="grid gap-4 sm:grid-cols-2">
    <FormField id={`${prefix}-password`} label="Password" error={errors.password}>
      <PasswordInput id={`${prefix}-password`} autoComplete="new-password" value={value} onChange={onChange} testId={`${prefix}-password-input`} />
      <StrengthMeter value={value} testId={`${prefix}-password-strength`} />
      <p className="text-xs text-[#75867E]">Almeno 8 caratteri con lettere e numeri. Per una password forte aggiungi maiuscole e simboli.</p>
    </FormField>
    <FormField id={`${prefix}-password-confirm`} label="Conferma password" error={errors.password_confirm}>
      <PasswordInput id={`${prefix}-password-confirm`} autoComplete="new-password" value={confirm} onChange={onConfirm} testId={`${prefix}-password-confirm-input`} />
    </FormField>
  </div>
);
